import React from "react";
import { connect } from "react-redux";
import {useLocation} from "react-router-dom";

import {ROUTES} from "../../../../routes";
import LookWizard from "./lookWizard/lookWizard";
import LookMainWizardSections from "./lookMainWizardSections";
import LookWizardContentButtons from "./lookWizard/lookWizardContentButtons";
import {getCurrentGroups} from "./lookWizard/lookWizardFunctions";
import LookWizardLmContent from "./lookWizard/lookWizardLmContent";
import LookWizardContextProvider from "./lookWizard/lookWizardContextProvider";

const LookMainSectionsMobileWizard = (props) => {

  const {wizardActiveStep, wizardActiveItem, wizardSelectedValues, contentHeight} = props;
  const location = useLocation();

  let isCompletedStep = false;
  const showWizard = location && location.pathname && location.pathname.includes(ROUTES.wizard);
  if (showWizard) {
    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;
  }

  return (
    <LookWizardContextProvider>
      <section className={"lm-section" + (showWizard && (wizardActiveStep === -1 || isCompletedStep) ? " lm-section--visible" : "")}>
        {showWizard ? (
          <LookWizard>
            <LookWizardLmContent/>
          </LookWizard>
        ) : null}
      </section>
      <section className={"lm-section lm-section--overflow" + (showWizard && wizardActiveStep > -1 && !isCompletedStep ? " lm-section--visible" : "")}>
        <LookMainWizardSections contentHeight={contentHeight}/>
        <div className="lm-section__footer">
          <LookWizardContentButtons/>
        </div>
      </section>
    </LookWizardContextProvider>
  )
};


const mapStateToProps = (store) => {
  const {wizardActiveStep, wizardActiveItem, wizardSelectedValues} = store.wizardState;

  return {
    wizardActiveStep,
    wizardActiveItem,
    wizardSelectedValues
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookMainSectionsMobileWizard)
